import type { BoardLayoutConfig, TimeSlot } from "../../../../../_logic/calendar-types"

export const MIN_EVENT_MINUTES = 5
export const CALENDAR_GRID_MINUTES = [5, 10, 15, 20, 30, 60] as const
export type CalendarGridMinutes = (typeof CALENDAR_GRID_MINUTES)[number]
export type CalendarView = "timeline" | "overview"
const HOUR_HEIGHT: Record<CalendarGridMinutes, number> = {
  5: 202.8,
  10: 144,
  15: 108,
  20: 90,
  30: 72,
  60: 48,
}

export const calendarScale = (minutes: CalendarGridMinutes) => ({
  slotMinutes: minutes,
  slotHeight: (HOUR_HEIGHT[minutes] * minutes) / 60,
  minEventHeight: 18,
})

export const calendarTimeSlots = (
  startHour: number,
  endHour: number,
  layout: BoardLayoutConfig,
): TimeSlot[] => {
  const slots: TimeSlot[] = []
  for (let minutes = startHour * 60; minutes <= endHour * 60; minutes += layout.slotMinutes) {
    const label = `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`
    slots.push({
      label,
      ariaLabel: label,
      value: minutes,
      showLabel: layout.slotMinutes >= 10 || minutes % 15 === 0,
    })
  }

  return slots
}
